export const KEY_REDUCER_SW = "sw";
export const PROGRESS_VALUE_REMOVE = -1;
